import { BonusActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetBonusesAction {
    type: typeof BonusActions.FETCH_BONUSES;
    payload: QueryParams;
    all?: any;
}
export function getBonuses(params: QueryParams): GetBonusesAction {
    return {
        type: BonusActions.FETCH_BONUSES,
        payload: params,
    };
}

interface QueryParamsAll extends QueryParams {
    all?: any;
}

export function getBonusesCsv(params: QueryParamsAll): GetBonusesAction {
    return {
        type: BonusActions.FETCH_BONUSES_CSV,
        payload: params,
        all: params.all,
    };
}

export interface GetBonusAction {
    type: typeof BonusActions.FETCH_BONUS;
    payload: {
        id: string | number;
    };
}
export function getBonus(id: string | number): GetBonusAction {
    return {
        type: BonusActions.FETCH_BONUS,
        payload: { id },
    };
}

export interface GenerateBonusFormData {
    userId: number | string | undefined;
    provider?: any;
    'provider.id'?: any;
    month?: any;
}
export interface GenerateBonusAction {
    type: typeof BonusActions.GENERATE_BONUS;
    payload: {
        data: GenerateBonusFormData;
        callbacks: SagaPromise<any>;
    };
}
export function generateBonus(data: GenerateBonusFormData, callbacks: SagaPromise<any>): GenerateBonusAction {
    return {
        type: BonusActions.GENERATE_BONUS,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncGenerateBonus = (data: GenerateBonusFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(generateBonus(data, { resolve, reject }));
    });
};

export interface GetExigentBonusStatusAction {
    type: typeof BonusActions.FETCH_EXIGENT_BONUS_STATUS;
    payload: {
        providerId: string | number;
    };
}
export function getExigentBonusStatus(providerId: string | number): GetExigentBonusStatusAction {
    return {
        type: BonusActions.FETCH_EXIGENT_BONUS_STATUS,
        payload: { providerId },
    };
}

export interface ResetExigentBonusStatusAction {
    type: typeof BonusActions.RESET_EXIGENT_BONUS_STATUS;
}
export function resetExigentBonusStatus(): ResetExigentBonusStatusAction {
    return {
        type: BonusActions.RESET_EXIGENT_BONUS_STATUS,
    };
}

export type Actions =
    | GetBonusesAction
    | GetBonusAction
    | GenerateBonusAction
    | GetExigentBonusStatusAction
    | ResetExigentBonusStatusAction;
